import React from "react";
import CrudPage, { ActiveBadge } from "@/components/CrudPage";
import { API } from "@/lib/api";

const COLUMNS = [
  { key: "image_path", label: "Resim", render: (p) => p.image_path
    ? <img src={`${API}/files/${p.image_path}`} alt={p.code} data-testid={`product-image-${p.code}`}
        className="w-10 h-10 object-cover rounded border border-border" />
    : <span className="text-muted-foreground text-xs">-</span> },
  { key: "code", label: "Ürün Kodu" },
  { key: "name", label: "Ürün Adı" },
  { key: "description", label: "Açıklama", render: (p) => p.description || "-" },
  { key: "active", label: "Durum", render: (p) => <ActiveBadge value={p.active} /> },
];

const FIELDS = [
  { name: "code", label: "Ürün Kodu", required: true, placeholder: "Örn: SAS-A" },
  { name: "name", label: "Ürün Adı", required: true },
  { name: "description", label: "Açıklama", full: true },
  { name: "image_path", label: "Ürün Resmi", type: "image", full: true },
  { name: "active", label: "Aktif", type: "checkbox" },
];

export default function Products() {
  return (
    <CrudPage
      title="Ürünler"
      subtitle="Ürün tanımları — ürün bazlı standart süreler Operasyon & Standart sayfasından yönetilir"
      endpoint="products"
      testidPrefix="products"
      defaultForm={{ active: true }}
      columns={COLUMNS}
      fields={FIELDS}
    />
  );
}
